import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  categories: null,
  categoriesLoading: false,
  categoriesError: false,
  selectedCategory: null,
  selectedBranch: null,
  trialVal: null,
  test: "123",
};

export const getAllCategoriesThunk = createAsyncThunk(
  "Categories/get",
  async () => {
    try {
      const res = await fetch("data/categories.json?v=" + Date.now());
      console.log(res);
      const categories = res;
      console.log(categories);
      return categories;
    } catch (err) {
      throw err;
    }
  }
);

const categorySlice = createSlice({
  name: "Categories",
  initialState: initialState,
  reducers: {
    SET_CATEGORY: (state, action) => {
      state.selectedCategory = action.payload;
    },

    SET_BRANCH: (state, action) => {
      state.selectedBranch = action.payload;
    },

    SET_TRIAL: (state, action) => {
      state.trialVal = action.payload;
    },

    SET_TEST: (state, action) => {
      state.test = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getAllCategoriesThunk.pending, (state, action) => {
      state.categoriesLoading = true;
      state.categories = null;
      state.categoriesError = false;
    });

    builder.addCase(getAllCategoriesThunk.fulfilled, (state, action) => {
      state.categoriesLoading = false;
      state.categories = action.payload;
      state.categoriesError = false;
    });

    builder.addCase(getAllCategoriesThunk.rejected, (state, action) => {
      state.categoriesLoading = false;
      state.categories = null;
      state.categoriesError = true;
    });
  },
});

export const { SET_CATEGORY, SET_BRANCH, SET_TRIAL, SET_TEST } =
  categorySlice.actions;
// export const resetState = () => ({
//   type: "mySlice/resetState",
// });

export const categoryReducer = categorySlice.reducer;
